import React, { ReactElement, useContext } from "react";
import { Divider, Grid, IconButton, ListItemIcon, Menu, MenuItem, Typography } from "@mui/material";
import { AccountCircle, AdminPanelSettings, Logout } from "@mui/icons-material";
import { useSignOut } from "../auth/useAuthentication";
import { UserContext, AuthState } from "../contexts/UserContext";
import { useNavigate } from "react-router-dom";

export function AdminMenu(): ReactElement | null {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const { user, authState } = useContext(UserContext);
    const [signOut] = useSignOut();
    const navigate = useNavigate();

    // Only render if user is authenticated and is admin
    if (authState !== AuthState.SignedIn || !user?.isAdmin) {
        return null;
    }

    const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const handleSignOutClicked = () => {
        handleCloseMenu();
        signOut();
        navigate('/');
    };

    const handleAdminDashboardClicked = () => {
        handleCloseMenu();
        navigate('/admin');
    };

    const handleAdminUsersClicked = () => {
        handleCloseMenu();
        navigate('/admin/users');
    };

    const handleAdminFeedbackClicked = () => {
        handleCloseMenu();
        navigate('/admin/feedback');
    };

    return (
        <div>
            <Grid container spacing={0} direction="row" justifyContent="center" alignItems="center">
                <Grid>
                    <Typography sx={{ color: "primary.contrastText" }} variant="body1">
                        {user?.email}
                    </Typography>
                </Grid>
                <Grid>
                    <IconButton aria-label="account of current user" aria-controls="menu-appbar" aria-haspopup="true" onClick={handleMenu} color="inherit">
                        <AccountCircle />
                    </IconButton>
                </Grid>

                <Menu
                    id="menu-appbar"
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                    }}
                    keepMounted
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                    }}
                    open={open}
                    onClose={handleCloseMenu}
                >
                    <MenuItem onClick={handleAdminDashboardClicked}>
                        <ListItemIcon>
                            <AdminPanelSettings fontSize="small" />
                        </ListItemIcon>
                        <Typography color="textPrimary">Dashboard</Typography>
                    </MenuItem>

                    <MenuItem onClick={handleAdminUsersClicked}>
                        <ListItemIcon>
                            <AdminPanelSettings fontSize="small" />
                        </ListItemIcon>
                        <Typography color="textPrimary">User Management</Typography>
                    </MenuItem>

                    <MenuItem onClick={handleAdminFeedbackClicked}>
                        <ListItemIcon>
                            <AdminPanelSettings fontSize="small" />
                        </ListItemIcon>
                        <Typography color="textPrimary">User Feedback</Typography>
                    </MenuItem>

                    <Divider />

                    <MenuItem onClick={handleSignOutClicked}>
                        <ListItemIcon>
                            <Logout fontSize="small" />
                        </ListItemIcon>
                        <Typography color="textPrimary">Sign Out</Typography>
                    </MenuItem>
                </Menu>
            </Grid>
        </div>
    );
}
